// extracted by mini-css-extract-plugin
module.exports = {"SocialNetworks":"SocialNetworks_SocialNetworks__32sFt","social_icons__link":"SocialNetworks_social_icons__link__1KCVR"};